import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const BrandsAPI = createApi({
    reducerPath: "BrandsAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders: (headers, { endpoint }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            headers.set("Accept", "application/json");

            // Apply JSON content-type except for multipart endpoints
            if (!["addBrands", "updateBrands", "updateBrandStatus"].includes(endpoint)) {
                headers.set("Content-Type", "application/json");
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        addBrands: builder.mutation({
            query: (formData) => ({
                url: "admin/brands/add-brand",
                method: "POST",
                body: formData,
            }),
        }),
        updateBrands: builder.mutation({
            query: ({ formData, id }) => ({
                url: `admin/brands/edit-brand/${id}`,
                method: "POST",
                body: formData,
            }),
        }),

        getBrandList: builder.query({
            query: () => `brands/list-brands`,
        }),

        getBrandsbyId: builder.query({
            query: (id) => `brands/show/${id}`,
        }),


        deleteBrand: builder.mutation({
            query: (id) => ({
                url: `admin/brands/delete-brand/${id}`,
                method: "DELETE",
            }),
        }),

        updateBrandStatus: builder.mutation({
            query: (formData) => ({
                url: "admin/brands/update-status",
                method: "POST",
                body: formData,
            }),
        }),
        listActiveBrands: builder.query({
            query: () => `brands/list-active-brands`,
        }),

    }),
});

export const { useAddBrandsMutation, useGetBrandListQuery, useGetBrandsbyIdQuery, useUpdateBrandsMutation, useDeleteBrandMutation, useUpdateBrandStatusMutation, useListActiveBrandsQuery} = BrandsAPI;
